// extracted by mini-css-extract-plugin
export default {"container":"page-public-bid-request_container__q0jmF"};